import { render, staticRenderFns } from "./vCautionaryInputs.vue?vue&type=template&id=880fdb4c"
import script from "./vCautionaryInputs.vue?vue&type=script&lang=ts&setup=true"
export * from "./vCautionaryInputs.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports